// extracted by mini-css-extract-plugin
export default {"loading-continer":"Loading_loading-continer__p9Eqk"};